import React, { useState, useEffect } from "react";
import api from "APP_ROOT/api";
import { Col } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import { LargeInput as FormInput, Save } from "MODULES/shared/components/Forms";
import { connect } from "react-redux";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { EMAIL } from "APP_ROOT/constants";
import * as actions from "MODULES/users/actions";
import { properCase } from "LIB/formatters/text";
import Submitted from "MODULES/session/components/ForgotPassword/Submitted";
import { onSuccess } from "LIB/submission";

function ForgotPassword({ ...props }) {
  const [tenant, setTenant] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.session.tenant().then(({ data }) => {
      setTenant(data);

      return function cleanup() {};
    });
  }, []);

  const success = () => setOpen(true);

  const submit = onSuccess(props.handleSubmit, success, props);

  return (
    <div className="login">
      <Submitted
        open={open}
        close={() => setOpen(false)}
        logoUrl={tenant && tenant.logo_url}
      />
      <div className="container-fluid">
        <div className="main">
          <div className="row">
            <Col md={4} mdOffset={4}>
              <div className="panel panel-default">
                <div className="panel-body">
                  <div className="text-center">
                    <img src={tenant && tenant.logo_url} alt="Logo" />
                  </div>
                  <br />
                  <h1 className="text-center margin-top-none">
                    Forgot Password?
                  </h1>
                  <p className="text-center">
                    Please enter your email to reset your password.
                  </p>
                  <form onSubmit={submit}>
                    <Field
                      name={EMAIL}
                      component={FormInput}
                      label={properCase(EMAIL)}
                      required
                    />
                    <br />
                    <div className="row">
                      <Col md={6} mdOffset={3}>
                        <Save {...props} icon="fa-unlock" text="Reset" />
                      </Col>
                    </div>
                  </form>
                </div>
              </div>
            </Col>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(actions.forgot(data))
}))(
  reduxForm({
    form: "forgotPassword",
    validate: values =>
      validator(values, f => {
        f.validate(EMAIL).satisfies(rules.required);
      })
  })(ForgotPassword)
);



// WEBPACK FOOTER //
// ./app/modules/session/components/ForgotPassword/ForgotPassword.jsx